import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { implog } from '@/api/implog';
import Button from '@/components/button';
import { modalStore } from '@/stores/modal';
import globalStore from '@/stores/store';

import styles from './styles.module.less';

const NotLoginWelcomeModal = () => {
  const {
    initialAwardconfig: { mobilereg }
  } = globalStore;

  const navigate = useNavigate();

  useEffect(() => {
    implog('not_login_welcome_modal_show');
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.main}>
        <div className={styles.item}>
          <div className={styles.item_title}>Authority:</div>
          <div className={styles.item_subtext}>Numerical Certification</div>
        </div>
        <div className={styles.item}>
          <div className={styles.item_title}>Formal:</div>
          <div className={styles.item_subtext}>Organization Registration</div>
        </div>
        <div className={styles.item}>
          <div className={styles.item_title}>Available Withdrawal:</div>
          <div className={styles.item_subtext}>60s to arrive</div>
        </div>
        <div className={styles.bottom}>
          <div className={styles.bottom_title}>Sign up and receive</div>
          <div className={styles.bottom_subtext}>${mobilereg} </div>
        </div>
      </div>
      <div className={styles.btn}>
        <Button
          block
          type="success"
          onClick={() => {
            navigate('/login');
            implog('not_login_welcome_modal_click');
            modalStore.closeModal('not-login-welcome-modal');
          }}
        >
          Access
        </Button>
      </div>
    </div>
  );
};

export default NotLoginWelcomeModal;
